import { get, post, put, del, upload } from './interface.js'

// 登录相关API
const login = (data) => {
  return post('/login', data)
}

// 获取用户信息
const getUserInfo = () => {
  return get('/user/info')
}

// 示例：获取比赛列表
const getCompetitionList = (params) => {
  return get('/competition/list', params)
}

// 示例：提交比赛成绩
const submitScore = (data) => {
  return post('/score/submit', data)
}

// 示例：更新比赛信息
const updateCompetition = (data) => {
  return put('/competition/update', data)
}

// 示例：删除比赛
const deleteCompetition = (id) => {
  return del('/competition/delete', { id })
}

// 文件上传
const uploadFile = (formData) => {
  return upload('/upload', formData)
}

// 获取微信JSSDK配置
const getWechatConfig = (params) => {
  return get('/wechat/config', params)
}

// 获取所有赛事列表
const getAllEventList = (params) => {
  return get('/Comppublish/getAllEventList', params)
}

// 统一的API对象，保持与原来项目相似的接口
const api = {
  // 基础请求方法
  get,
  post,
  put,
  delete: del,
  upload,
  
  // 具体业务API
  login,
  getUserInfo,
  getCompetitionList,
  submitScore,
  updateCompetition,
  deleteCompetition,
  uploadFile,
  getWechatConfig,
  getAllEventList
}

export default api